import ProjectSession from "../../../../../model2/project/project-session"
import {SpaceProto} from "../../../../../model2/space/space-proto"
import Workspace from "../../../../../model2/space/workspaces/workspace"
import {ItemDisplay} from "../../../../../model2/item/@type"
import {entitySelectorProjectSpaces} from "./get-spaces"

// Mirrors the filter (VISIBLE/GHOST_VISIBLE, !isView && !isTag), sort
// (alphabetical) and expand (treeIsExpandedProjectSelector) logic
// `ProjectTree_New.renderListItems` applies, so the keyboard cursor visits
// rows in the same order they're actually drawn. Kept in sync by hand -- see
// the same trade-off, for the same reason, in `TaskFinderMain.getSiblingIndex`.
function collectVisible(projects: ProjectSession[], out: ID[]) {
    const filtered = _.filter(projects, (project: ProjectSession) => {
        return [ItemDisplay.VISIBLE, ItemDisplay.GHOST_VISIBLE].includes(project.treeDisplay)
            && !project.isView && !project.isTag
    })

    _.orderBy(filtered, (project: ProjectSession) => project.name, 'asc').forEach((project: ProjectSession) => {
        if (project.treeDisplay === ItemDisplay.VISIBLE) {
            out.push(project.id)
        }

        if (project.treeIsExpandedProjectSelector && !_.isEmpty(project.treeChildren)) {
            collectVisible(project.treeChildren, out)
        }
    })
}

// Ordered ids of the currently SELECTABLE (VISIBLE) rows across every space,
// for ArrowUp/ArrowDown/Enter -- ghost (ACL-restricted) rows are skipped but
// still descended into, same as a click would do.
export function flattenSelectableProjectIds(): ID[] {
    const out: ID[] = []

    _.map(entitySelectorProjectSpaces(), (space: SpaceProto) => {
        const roots = space instanceof Workspace ? [space.project] : space.rootProjects
        collectVisible(roots, out)
    })

    return out
}
